import { Environment } from 'src/common/constants/Environment';

export function isProduction(nodeEnv: string): boolean {
  return nodeEnv === Environment.PRODUCTION;
}
